import { useState } from 'react';

const confirmDialogInitialState = {
  open: false,
  title: '',
  message: '',
  onConfirm: null,
  confirmText: 'Confirm',
  confirmColor: 'primary',
};

const useConfirmDialog = () => {
  const [confirmDialog, setConfirmDialog] = useState(confirmDialogInitialState);

  const openConfirmDialog = ({ title, message, onConfirm, confirmText = 'Confirm', confirmColor = 'primary' }) => {
    setConfirmDialog({
      open: true,
      title,
      message,
      onConfirm: () => {
        onConfirm();
        setConfirmDialog(prev => ({ ...prev, open: false }));
      },
      confirmText,
      confirmColor
    });
  };

  const closeConfirmDialog = () => {
    setConfirmDialog(prev => ({ ...prev, open: false }));
  };

  return {
    confirmDialog,

    openConfirmDialog,
    closeConfirmDialog,
  };
};

export default useConfirmDialog;
